import { PREFIX_OPTIONS } from '@/data/prefixes';

/**
 * Returns array of phone number prefixes which are available for given user based on allowed country calling codes
 * @param req
 * @returns allowedPrefixes - array of phone number prefixes
 */

export const mapCountryCodesToPrefixes = async (
    allowedCountryCallingCodes?: string[],
) => {
    const allowedPrefixes: string[] = [];

    if (allowedCountryCallingCodes) {
        for (const code of allowedCountryCallingCodes) {
            const prefixOption = PREFIX_OPTIONS.find((option) => {
                return option.countryCode === code;
            });

            if (prefixOption?.value) {
                allowedPrefixes.push(prefixOption.value);
            }
        }
    }
    return allowedPrefixes.length > 0 ? allowedPrefixes : ['420'];
};
